  window.onload = function() {
    var element = document.querySelector('.f-brands[data-open="false"] ');
    if (element) {
      element.setAttribute('data-open', 'true');
    }
  };

// SHITTY HEADER FIX
 document.addEventListener('DOMContentLoaded', function() {
      const searchTrigger = document.querySelector('.wt-header__search-trigger');
      const searchClose = document.querySelector('.wt-header__search__close');
      const headerPanel = document.querySelector('.wt-header__panel');

      headerPanel.style.visibility = 'visible';
      headerPanel.style.opacity = '1';

      searchTrigger.addEventListener('click', function() {
        headerPanel.style.visibility = 'hidden'; // Hide the panel
        headerPanel.style.opacity = '0'; // Optional: fade out
      });

      searchClose.addEventListener('click', function() {
        headerPanel.style.visibility = 'visible'; // Show the panel
        headerPanel.style.opacity = '1'; // Optional: fade in
      });
    });

// EXPAND TEXT
document.addEventListener("DOMContentLoaded", function() {
    var bio = document.querySelector('.bio-text');
    var expandButton = document.querySelector('.expand');

    if (!bio || !expandButton) return;

    var initialHeight = window.innerWidth > 768 ? 120 : 120; // wiewport ? desktop box height : mobile
    var autoHeight = bio.scrollHeight;
    var isExpanded = false;

    if (autoHeight > initialHeight) {
        bio.style.height = initialHeight + "px";
        expandButton.style.display = "block";
    } else {
        bio.style.height = autoHeight + "px";
    }

    expandButton.addEventListener("click", function() {
        if (!isExpanded) {
            bio.style.transition = "height 1s ease-in-out";
            bio.style.height = autoHeight + "px";
            expandButton.textContent = "... READ LESS";
        } else {
            bio.style.transition = "height 1s ease-in-out";
            bio.style.height = initialHeight + "px";
            expandButton.textContent = "... READ MORE";
        }
        isExpanded = !isExpanded; // Toggle state
    });
});

// ARTWORK DETAILS
document.addEventListener('DOMContentLoaded', function () {

  function slideUp(element, duration = 300) {
    element.style.height = element.offsetHeight + 'px';
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = duration + 'ms';
    element.style.webkitTransitionProperty = 'height, margin, padding';
    element.style.webkitTransitionDuration = duration + 'ms';

    element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    
    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.removeProperty('-webkit-transition-duration');
      element.style.removeProperty('-webkit-transition-property');
    }, duration);
  }

  function slideDown(element, duration = 300) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;
    let height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    
    element.offsetHeight;
    
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = duration + 'ms';
    element.style.webkitTransitionProperty = 'height, margin, padding';
    element.style.webkitTransitionDuration = duration + 'ms';

    element.style.height = height + 'px';
    
    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.removeProperty('-webkit-transition-duration');
      element.style.removeProperty('-webkit-transition-property');
    }, duration);
  }

  function openSection(targetId) {
    const sections = document.querySelectorAll('.accordion-text');
    const links = document.querySelectorAll('.accordion-link');

    sections.forEach(function(section) {
      if (section.id !== targetId && window.getComputedStyle(section).display !== 'none') {
        slideUp(section, 300);
      }
    });

    const targetSection = document.getElementById(targetId);
    if (window.getComputedStyle(targetSection).display === 'none') {
      slideDown(targetSection, 300);
    }

    links.forEach(function(link) {
      link.classList.remove('accordion-link_on');
    });
    const targetLink = document.querySelector(`[data-target="${targetId}"]`);
    targetLink.classList.add('accordion-link_on');
  }

  // if (window.innerWidth > 899) {
    openSection('a1');
  // } 

  const links = document.querySelectorAll('.accordion-link');
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default anchor behavior.
      const targetId = link.getAttribute('data-target'); // Get the target id.
      openSection(targetId); // Open the target section with sliding animation.
    });
  });
});

